let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eKFCm")).then(() => parcelRequire('9m5Rp'));